import React from 'react';
import { Link } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import Logo from '../components/Logo';
import PublicSiteHeader from '../components/landing/PublicSiteHeader';
import PublicSiteFooter from '../components/landing/PublicSiteFooter';
import { GlowButton } from '../components/landing/LandingPrimitives';
import InquiryModal from '../features/auth/InquiryModal';
import LoginForm from '../features/auth/LoginForm';
import { useLoginPage } from '../features/auth/useLoginPage';

const Login = () => {
  const isNativeApp = Capacitor.isNativePlatform();
  const {
    method,
    phone,
    setPhone,
    otp,
    setOtp,
    otpSent,
    resendCooldown,
    handleSendOtp,
    handleMethodToggle,
    handleChangePhone,
    isRegistering,
    regName,
    setRegName,
    regFacilityName,
    setRegFacilityName,
    regPassword,
    setRegPassword,
    regConfirmPassword,
    setRegConfirmPassword,
    handleRegister,
    username,
    setUsername,
    password,
    setPassword,
    error,
    loading,
    showInquiry,
    setShowInquiry,
    handleSubmit,
  } = useLoginPage();

  return (
    <div className="ga-bg flex min-h-screen flex-col text-ga-text-primary">
      {isNativeApp ? (
        <header className="ga-safe-top fixed left-0 right-0 top-0 z-50 border-b border-ga-border-subtle bg-ga-bg-surface/80 backdrop-blur-md">
          <div className="mx-auto flex h-16 w-full max-w-6xl items-center px-4">
            <Logo showTagline />
          </div>
        </header>
      ) : (
        <PublicSiteHeader>
          <Link to="/login" className="text-sm font-semibold text-ga-text-primary">
            Login
          </Link>
          <GlowButton as={Link} to="/login" className="px-4 py-2 text-xs md:text-sm">
            Get started
          </GlowButton>
        </PublicSiteHeader>
      )}

      <div className="ga-safe-mt-header flex flex-1 items-center justify-center p-4 md:p-6">
        <div className="w-full max-w-md">
          <div className="rounded-ga-lg border border-ga-border-subtle bg-ga-bg-surface p-6 shadow-ga-soft md:p-8">
            <div className="mb-8 text-center">
              <div className="mb-4 flex justify-center">
                <Logo size="lg" showTagline />
              </div>
              <h1 className="mb-2 text-2xl font-bold text-ga-text-primary md:text-3xl">
                {isRegistering ? 'Set Up Your Ground' : 'Welcome'}
              </h1>
              <p className="text-ga-text-muted">
                {isRegistering
                  ? 'Almost there — finish your account setup'
                  : 'Enter your phone number to sign in or get started'}
              </p>
            </div>

            <LoginForm
              method={method}
              phone={phone}
              onPhoneChange={setPhone}
              otp={otp}
              onOtpChange={setOtp}
              otpSent={otpSent}
              resendCooldown={resendCooldown}
              onSendOtp={handleSendOtp}
              onMethodToggle={handleMethodToggle}
              onChangePhone={handleChangePhone}
              isRegistering={isRegistering}
              regName={regName}
              onRegNameChange={setRegName}
              regFacilityName={regFacilityName}
              onRegFacilityNameChange={setRegFacilityName}
              regPassword={regPassword}
              onRegPasswordChange={setRegPassword}
              regConfirmPassword={regConfirmPassword}
              onRegConfirmPasswordChange={setRegConfirmPassword}
              onRegister={handleRegister}
              username={username}
              onUsernameChange={setUsername}
              password={password}
              onPasswordChange={setPassword}
              error={error}
              loading={loading}
              onSubmit={handleSubmit}
            />
          </div>
        </div>
      </div>

      {!isNativeApp && <PublicSiteFooter />}

      {showInquiry && <InquiryModal onClose={() => setShowInquiry(false)} />}
    </div>
  );
};

export default Login;
